import * as Yup from 'yup';

export const nameAndImage = Yup.object({
  name: Yup.string().required(),
  imageType: Yup.string().optional(),
  customImageData: Yup.string().optional(),
  purpose_sub_type: Yup.string().required('Please choose a sepecific goal type.'),
});
